import { render, staticRenderFns } from "./InvitationDialog.vue?vue&type=template&id=41e6a1c6&scoped=true"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./InvitationDialog.vue?vue&type=style&index=0&id=41e6a1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e6a1c6",
  null
  
)

export default component.exports